import {Alert} from "@mui/material";
import {useLocation, useNavigate} from "react-router";
import {useTranslation} from "react-i18next";
import {needsAttention} from "../../model/mailServer/MailServer.ts";
import {useMailServerHealth} from "../../hooks/useMailServerHealth.ts";
import {MAIL_SERVER_SETTINGS_PATH} from "../../service/routeProvider.tsx";
import {DefaultButton} from "../buttons/DefaultButton.tsx";
import {dangerFillSx} from "../buttons/dangerFillSx.ts";

const MailServerHealthBanner = ({className}: {className?: string}) => {
    const {t} = useTranslation();
    const health = useMailServerHealth();
    const {pathname} = useLocation();
    const navigate = useNavigate();

    if (!needsAttention(health) || pathname.startsWith(MAIL_SERVER_SETTINGS_PATH)) {
        return null;
    }

    const deactivated = health === "DEACTIVATED";

    return <Alert
        severity={deactivated ? "error" : "warning"}
        className={className}
        action={
            <DefaultButton
                textKey="settings.mailServer.bannerAction"
                onClick={() => { void navigate(MAIL_SERVER_SETTINGS_PATH); }}
                sx={deactivated ? dangerFillSx : undefined}
                compact
            />
        }
    >
        {t(deactivated
            ? "settings.mailServer.bannerDeactivated"
            : "settings.mailServer.bannerFailing")}
    </Alert>;
};

export default MailServerHealthBanner;
